import Pagination from '@mui/material/Pagination';
import SkeletonsTable from '../SkeletonsTable';
import SolicitudAlternativaTableRow from '../SolicitudAlternativaTableRow';

const SolicitudAlternativasTable = ({
    loading,
    hasItems,
    items,
    onAction,
    currPage,
    paginationCount,
    onPageChange,
}) => (
    <div className="w-100 d-flex flex-column align-items-end content-table">
        <div className="table-responsive">
            <table className="table">
                <thead>
                    <tr>
                        <th>Solicitud</th>
                        <th>Presupuesto Origen</th>
                        <th>Cliente</th>
                        <th>Pieza</th>
                        <th className="text-center">Motivo</th>
                        <th className="text-center">Recambista</th>
                        <th className="text-center">At. Cliente</th>
                        <th
                            className="text-center"
                            style={{ minWidth: '140px' }}
                        >
                            Estado
                        </th>
                        <th className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? <SkeletonsTable /> : null}

                    {!loading && hasItems
                        ? items.map((item) => (
                              <SolicitudAlternativaTableRow
                                  key={item.id}
                                  item={item}
                                  onAction={onAction}
                              />
                          ))
                        : null}

                    {!loading && !hasItems ? (
                        <tr>
                            <td colSpan="9" className="text-center py-4">
                                No hay solicitudes de alternativa
                            </td>
                        </tr>
                    ) : null}
                </tbody>
            </table>
        </div>

        <Pagination
            className="mt-3"
            count={paginationCount}
            page={currPage}
            onChange={onPageChange}
        />
    </div>
);

export default SolicitudAlternativasTable;
